import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { Link } from 'react-router-dom'
import { get } from 'lodash'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { Modal } from 'containers/misc'
import { Table, Data } from 'components/layout/Table'
import { ButtonGroup, Button, BadgesLevels } from 'components/misc'
import { tasks as tasksLayout } from 'constants/layout'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { apiConfiguration } from 'helpers/decorators/api'
import { compose } from 'recompose'
import config from 'config'
import { FormattedMessage } from 'react-intl'
import styles from './tasks-activities-table.styl'
import { isAssessorManagementEnabledForActivity } from '../../../../helpers/assessorHelper'

const enhance = compose(
  apiConfiguration({
    getValues: [
      CONFIGURATION_KEYS.enableAssessorWelcomeEmail.id
    ],
    inOrganizationDetail: true
  }))

class TasksActivitiesTable extends Component {
  static propTypes = {
    section: PropTypes.string.isRequired,
    tasks: PropTypes.object.isRequired,
    list: PropTypes.array,
    approveModal: PropTypes.func.isRequired,
    returnModal: PropTypes.func.isRequired,
    setParams: PropTypes.func,
    modal: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)
    this.key = uuid.v1()
    this.state = {
      activityIdApprove: null,
      activityIdReturn: null,
      isAssessorManagementEnabled: null
    }
  }

  state = {
    note: null,
    activityState: null
  }

  handleApproveModal = (activityIdApprove, activityState, isAssessorManagementEnabled) => {
    this.setState(
      {
        activityIdApprove,
        activityState,
        isAssessorManagementEnabled
      },
      () => {
        this.props.modal(`modal-approve-activity-${this.key}`)
      }
    )
  }

  handleReturnModal = (activityIdReturn, isAssessorManagementEnabled) => {
    this.setState(
      {
        activityIdReturn,
        isAssessorManagementEnabled
      },
      () => {
        this.props.modal(`modal-return-activity-${this.key}`)
      }
    )
  }

  activityLinkFor = award => {
    const level = `${get(award, 'awardLevel.value')}-level`.toLowerCase()

    return `${config.publicPath}/participants/${get(award, 'participant.id')}/${level}/${this.props.section}`
  }

  handleShowNote = note => {
    this.setState({ note })
    this.props.modal(`modal-show-note-${this.key}`)
  }

  getAssessorInfo = (award, activity, assessorEmail, assessor, note, isAssessorManagementEnabled, rejectedInProgress) => {
    const rejectedByAssessor = get(activity, 'isAcceptedByAssessor') === false && note !== null

    if (isAssessorManagementEnabled) {
      const id = get(activity, 'assessor.person.id') || get(assessor, 'person.id')

      const orgId = get(activity, 'assessor.organization.id') || get(assessor, 'organization.id')

      if (rejectedByAssessor) {

        return (<div className={styles.assessorInfo}>

          <div className={styles.assessor}>
            <div className={styles.required}>
              <Link to={this.activityLinkFor(award)}>
                <FormattedMessage
                  className="control-label"
                  id="label.assessor_required"
                  defaultMessage="Assessor required"
                />
              </Link>
            </div>
          </div>
          <div className={styles.rejection}>

            <div className={styles.rejectionInfo}>
              {rejectedInProgress && <FormattedMessage
                className="control-label"
                id="label.running_activity_was_rejected"
                defaultMessage="Running activity was rejected"
              />}

              {!rejectedInProgress &&
                <FormattedMessage
                  className="control-label"
                  id="label.setup_activity_was_rejected"
                  defaultMessage="Activity was rejected during setup"
                />
              }
            </div>

            <br />
           <div className={styles.rejectedBy}>
              <FormattedMessage
                className="control-label"
                id="label.activity_rejected_by"
                defaultMessage="Activity was rejected by"
              />
              &nbsp;
              {assessor ? <Link to={{ pathname: `${config.publicPath}/organizations/${orgId}/assessors/${id}/detail` }}>
                {get(assessor, 'person.name')}
              </Link> : assessorEmail}
            </div>

            <div>
              <Button
                type="button"
                link
                intlKey="button.view_reason"
                onClick={() => this.handleShowNote(note)}
              >
                View reason
              </Button>
            </div>
          </div>
        </div>)
      } else {
        // without setup assessor - need help
        if (!get(activity, 'assessorEmail')) {
          return (
            <div className={styles.assessorInfo}>

              <div className={styles.assessor}>
                <div className={styles.required}>
                  <Link to={this.activityLinkFor(award)}>
                    <FormattedMessage
                      className="control-label"
                      id="label.assessor_required"
                      defaultMessage="Assessor required"
                    />
                  </Link>
                </div>
              </div>


              {get(activity, 'activityCategory.userDefined') && <div className={styles.other}>
                <FormattedMessage
                  id="label.other_activity_selected"
                  defaultMessage="OTHER activity was selected"
                />
              </div>}
              {note && <div>
                <br />
                <Button type="button" link intlKey="button.view_reason" onClick={() => this.handleShowNote(note)}>
                  View reason
                </Button>
              </div>}
            </div>
          )
        }

        if (!get(activity, 'assessor')) {
          return (
            <div className={styles.assessorInfo}>

              <div className={styles.assessor}>
                <div className={styles.assessorStatus}>
                  <FormattedMessage id="label.new_assessor" defaultMessage="New assessor" />
                </div>
                <br />
                <div className={styles.existing}>
                  {get(activity, 'assessorName')} <br />
                  {get(activity, 'assessorEmail')} <br />
                  {get(activity, 'assessorRelevantExperience')}
                </div>
              </div>
            </div>
          )
        }

        return (
          <div className={styles.assessorInfo}>

            <div className={styles.assessor}>
              <div className={styles.assessorStatus}>
                {get(activity, 'assessorRelevantExperience') && <FormattedMessage
                  id="label.existing_assessor_new_activity_registration"
                  defaultMessage="Existing assessor - new activity registration"
                />}
                {!get(activity, 'assessorRelevantExperience') && <FormattedMessage
                  id="label.approved_assessor_with_activity"
                  defaultMessage="Approved assessor with activity"
                />}
              </div>
              <br />
              <div className={styles.existing}>
                {<Link to={{ pathname: `${config.publicPath}/organizations/${orgId}/assessors/${id}/detail` }}>{get(activity, 'assessor.person.name')}</Link>} <br />
                {get(activity, 'assessor.person.email')}<br />
                {get(activity, 'assessorRelevantExperience') &&
                  <small>{get(activity, 'assessorRelevantExperience')}</small>}
              </div>
            </div>
          </div>
        )
      }

    } else {
      // disable assessor web
      return (<div>
        {get(activity, 'assessorName') || get(activity, 'assessorEmail') && get(activity, 'assessorPhone') || '-'}
        <br />
        {get(activity, 'assessorEmail') && <small>{get(activity, 'assessorEmail')}</small> ||
          get(activity, 'assessorPhone') && <small>{get(activity, 'assessorPhone')}</small>}
        <br />
        {get(activity, 'assessorRelevantExperience') && <small>{get(activity, 'assessorRelevantExperience')}</small>}
      </div>)
    }
  }

  render () {
    const {
      tasks,
      list,
      tasks: { loading, offset, limit, pages, sort },
      setParams,
      approveModal,
      returnModal,
      configuration,
      codeLists
    } = this.props
    const tasksList = list || tasks.list

    const assessorWelcomeEmailCfg = configuration && configuration.values[CONFIGURATION_KEYS.enableAssessorWelcomeEmail.id]

    const isAssessorWelcomeEmailEnabled = get(assessorWelcomeEmailCfg, 'booleanValue')

    return (
      <div>
        <Table
          loading={loading}
          length={tasksList.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          setParams={setParams}
          ths={tasksLayout.activityApprovalTableHeaders}
          hideLimit
        >
          <Data>
            {tasksList.map(({ id, activity, assessorEmail, assessor, award, participantPerson, note, rejectedInProgress }) => {

              const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(activity)

              return (
                <tr key={id}>
                  <td>
                    <Link to={`${config.publicPath}/participants/${get(award, 'participant.id')}`}>
                      {get(award, 'participant.globalId') ||
                        get(award, 'participant.id')}
                    </Link>
                  </td>
                  <td>{get(participantPerson, 'firstName')}</td>
                  <td>{get(participantPerson, 'lastName')}</td>
                  <td>
                    <BadgesLevels levels={[award]} participantId={get(award, 'participant.id')} single />
                  </td>
                  <td>
                    {get(activity, 'activityCategory.parent.translatedName')}
                  </td>
                  <td>
                    <Link to={this.activityLinkFor(award)}>
                      {get(activity, 'activityCategory.translatedName')}
                    </Link>
                  </td>
                  <td>{get(activity, 'aim')}</td>
                  <td>
                    {this.getAssessorInfo(award, activity, assessorEmail, assessor, note, isAssessorManagementEnabled, rejectedInProgress)}
                  </td>
                  <td className="text--center">
                    <ButtonGroup>
                      <Button
                        type="button"
                        onClick={() =>
                          this.handleApproveModal(get(activity, 'id'), get(activity, 'activityState.value'), isAssessorManagementEnabled)
                        }
                        intlKey={isAssessorManagementEnabled ? 'button.authorize' : 'button.approve'}
                        tiny
                      >
                        {isAssessorManagementEnabled ? 'Authorize' : 'Approve'}
                      </Button>
                      <Button
                        type="button"
                        onClick={() =>
                          this.handleReturnModal(get(activity, 'id'), isAssessorManagementEnabled)
                        }
                        intlKey="button.revise"
                        secondary
                        tiny
                      >
                        Revise
                      </Button>
                    </ButtonGroup>
                  </td>
                </tr>
              )
            })}
          </Data>
        </Table>
        <Modal id={`modal-approve-activity-${this.key}`} customActions>
          <TaskApprove
            approve={approveModal}
            id={this.state.activityIdApprove}
            modal={this.props.modal}
            isActivityTask={true}
            activityState={this.state.activityState}
            isAssessorWelcomeEmailEnabled={isAssessorWelcomeEmailEnabled}
            isAssessorManagementEnabled={this.state.isAssessorManagementEnabled}
          />
        </Modal>
        <Modal id={`modal-return-activity-${this.key}`} customActions enableOverflow>
          <TaskReturn
            returnTask={returnModal}
            id={this.state.activityIdReturn}
            modal={this.props.modal}
            isAssessorManagementEnabled={this.state.isAssessorManagementEnabled}
            showReasons
            codeLists={codeLists}
          />
        </Modal>
        <Modal
          id={`modal-show-note-${this.key}`}
          closeAction="Close"
          intlKeyClose="modal.close"
        >
          <div>
            <h2 className="text--center">
              <FormattedMessage id="title.rejection_reason" defaultMessage="Reason of rejection" />
            </h2>
            <p>{this.state.note}</p>
          </div>
        </Modal>
      </div>
    )
  }
}

export default enhance(TasksActivitiesTable)
